import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Agentation } from 'agentation';
import '@/App.css';
import SEO from './components/SEO';
import StructuredData from './components/StructuredData';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Doctors from './components/Doctors';
import Services from './components/Services';
import Footer from './components/Footer';
import MentionsLegales from './components/MentionsLegales';
import PolitiqueConfidentialite from './components/PolitiqueConfidentialite';
import CGV from './components/CGV';
import Version from './components/Version';
import LocalSeoPage from './components/LocalSeoPage';

const BeforeAfter = lazy(() => import('./components/BeforeAfter'));
const Pricing = lazy(() => import('./components/Pricing'));
const Blog = lazy(() => import('./components/Blog'));
const FAQ = lazy(() => import('./components/FAQ'));
const GoogleReviews = lazy(() => import('./components/GoogleReviews'));
const Contact = lazy(() => import('./components/Contact'));

const LocalSeoRoute = ({ pageKey }) => (
  <div className="bg-white min-h-screen">
    <Navigation />
    <LocalSeoPage pageKey={pageKey} />
    <Footer />
  </div>
);

const Home = () => (
  <div className="bg-white">
    <SEO
      title="Médecine esthétique à Rouvroy près de Lens et Liévin | MN Médecine Esthétique"
      description="Cabinet de médecine esthétique à Rouvroy (62320), dans les Hauts-de-France. Patients de Lens, Liévin, Lille, Arras, Douai, Béthune, Valenciennes et Dunkerque. Hydrafacial, lasers Fotona et Neauvia, mésothérapie, injections. Médecins diplômés — sur rendez-vous."
      keywords="médecine esthétique Hauts-de-France, médecine esthétique Rouvroy, médecine esthétique Lens, médecine esthétique Liévin, médecine esthétique Lille, médecine esthétique Arras, médecine esthétique Douai, médecine esthétique Béthune, médecine esthétique Valenciennes, médecine esthétique Dunkerque, hydrafacial, laser esthétique, mésothérapie, injections esthétiques, Dr Ghelboun"
      url={window.location.pathname.startsWith('/v2') ? '/v2/' : '/'}
    />
    <StructuredData />
    <Navigation />
    <Hero />
    <About />
    <Doctors />
    <Services />
    <Suspense fallback={<div className="py-10 text-center text-gray-500">Chargement...</div>}>
      <BeforeAfter />
      <Pricing />
      <Blog />
      <FAQ />
      <GoogleReviews />
      <Contact />
    </Suspense>
    <Footer />
  </div>
);

function App() {
  const basename =
    process.env.NODE_ENV === 'development'
      ? ''
      : process.env.REACT_APP_BASENAME || (window.location.pathname.startsWith('/v2') ? '/v2' : '');

  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/version" element={<Version />} />
          <Route path="/medecine-esthetique-lens" element={<LocalSeoRoute pageKey="lens" />} />
          <Route path="/medecine-esthetique-lievin" element={<LocalSeoRoute pageKey="lievin" />} />
          <Route
            path="/medecine-esthetique-henin-beaumont"
            element={<LocalSeoRoute pageKey="henin" />}
          />
          <Route path="/medecine-esthetique-pas-de-calais" element={<LocalSeoRoute pageKey="hub" />} />
          <Route path="/hydrafacial-lens-rouvroy" element={<LocalSeoRoute pageKey="hydrafacial" />} />
        </Routes>
      </BrowserRouter>
      {process.env.NODE_ENV === 'development' && (
        <Agentation endpoint="http://localhost:4747" />
      )}
    </div>
  );
}

export default App;